/* eslint-disable max-classes-per-file */
import { ObjectUtils } from "~app/common/utils/object-utils";
import { AtgardStatuses as AtgardStatusViewModel } from "../../../models/atgardstatus/atgardstatuses-models";
import { AtgardStatusBase, IAtgardStatus, IAtgardStatusIcon, IAtgardStatusTooltip } from "./atgardheadericons-models";

export class NvbAtgardStatus extends AtgardStatusBase implements IAtgardStatus {
    header = "NV Bedömning";
    tooltips: IAtgardStatusTooltip[] = this.getTooltips();
    icons: IAtgardStatusIcon[] = [
        {
            visible: true,
            iconclass1: "far fa-leaf",
            iconclass2: this.status.naturvardesbedomning.nvbKravsEj === true ? "fal fa-slash" : "",
            incomplete: ObjectUtils.isNullOrUndefined(this.status.naturvardesbedomning.utfordDatum),
            warning: false
        }
    ];

    constructor(model: AtgardStatusViewModel) {
        super(model);
    }
    visible(): boolean {
        return ObjectUtils.isNullOrUndefined(this.status.naturvardesbedomningDatumLegacy);
    }

    private getTooltips(): IAtgardStatusTooltip[] {
        const tooltips = [];
        if (this.status.naturvardesbedomning.nvbKravsEj === true) {
            tooltips.push({
                header: "Naturvärdebedömning",
                text: "Krävs ej",
                visible: true
            });
        }
        tooltips.push({
            header: "Utförd av",
            text: this.status.naturvardesbedomning.utfordAv,
            visible: true
        });
        tooltips.push({
            header: "Datum",
            text: this.status.naturvardesbedomning.utfordDatum,
            visible: true
        });
        return tooltips;
    }
}

export class NvbLegacyAtgardStatus extends AtgardStatusBase implements IAtgardStatus {
    header = "NV Bedömning legacy";
    tooltips = [
{
    header: "Datum",
    text: this.status.naturvardesbedomningDatumLegacy,
    visible: true
} as IAtgardStatusTooltip
    ];
    icons: IAtgardStatusIcon[] = [
        {
            visible: true,
            iconclass1: "far fa-leaf",
            incomplete: false,
            warning: false
        }
    ];
    constructor(model: AtgardStatusViewModel) {
        super(model);
    }
    visible(): boolean {
        return ObjectUtils.hasValue(this.status.naturvardesbedomningDatumLegacy);
    }
}
